import { createTripletGlyphIcon } from '../../../utils/createTripletGlyphIcon';

/** Source: `svg-to-react-generator/source-svgs/outline/{S,M,L}/add.svg` */
export const AddIcon = createTripletGlyphIcon('AddIcon', {
  s: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.00098 1.44727C8.38715 1.44777 8.7002 1.76117 8.7002 2.14746V7.30176H13.8545C14.2409 7.30202 14.5547 7.61552 14.5547 8.00195C14.5543 8.38808 14.2406 8.70091 13.8545 8.70117H8.7002V13.8555C8.70006 14.2416 8.38707 14.5552 8.00098 14.5557C7.61446 14.5557 7.30091 14.242 7.30078 13.8555V8.70117H2.14648C1.76011 8.70117 1.44568 8.38824 1.44531 8.00195C1.44531 7.61535 1.75989 7.30176 2.14648 7.30176H7.30078V2.14746C7.30078 1.76086 7.61438 1.44727 8.00098 1.44727Z"
        fill="currentColor"
      />
    </svg>
  ),
  m: () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 1.71582C9.38654 1.71589 9.7002 2.02946 9.7002 2.41602V8.30176H15.5859C15.9724 8.30189 16.2861 8.61544 16.2861 9.00195C16.2859 9.38824 15.9723 9.70201 15.5859 9.70215H9.7002V15.5879C9.69986 15.9742 9.38634 16.288 9 16.2881C8.61372 16.288 8.30014 15.9741 8.2998 15.5879V9.70215H2.41406C2.02774 9.70202 1.71413 9.38825 1.71387 9.00195C1.71387 8.61544 2.02758 8.30189 2.41406 8.30176H8.2998V2.41602C8.2998 2.0295 8.61351 1.71595 9 1.71582Z"
        fill="currentColor"
      />
    </svg>
  ),
  l: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 2.32031C12.4969 2.3204 12.8993 2.72379 12.8994 3.2207V11.1016H20.7812C21.2781 11.1017 21.6806 11.5051 21.6807 12.002C21.6806 12.4988 21.2781 12.9012 20.7812 12.9014H12.8994V20.7832C12.8992 21.28 12.4969 21.6825 12 21.6826C11.5031 21.6826 11.0998 21.2801 11.0996 20.7832V12.9014H3.21875C2.72181 12.9013 2.31845 12.4989 2.31836 12.002C2.31846 11.505 2.72181 11.1016 3.21875 11.1016H11.0996V3.2207C11.0997 2.72377 11.5031 2.32038 12 2.32031Z"
        fill="currentColor"
      />
    </svg>
  ),
});
